import React, { useContext } from 'react';

import cx from 'classnames';

import LandingPageContext from '../../contexts/LandingPageContext';
import s from './index.module.css';
import InlineBuilderItinerary from './InlineBuilderItinerary';
import PortalItinerary from './PortalItinerary';
import { IPageHeaderProps } from './types';
import { Wrapper } from './Wrapper';

function PageHeader(props: IPageHeaderProps) {
  const { links, disabled = false } = props;
  const { isPortalItinerary = false, isItinerariesItem, hasHeader } = useContext(LandingPageContext);

  if (!hasHeader) {
    return (
      <Wrapper links={links} disabled={disabled} isEmpty>
        <div
          className={cx(s.header, s.headerNoBorder, isItinerariesItem && !isPortalItinerary && s.headerItinerary)}
          id="landingHeader"
        />
      </Wrapper>
    );
  }

  if (isPortalItinerary) return <PortalItinerary {...props} />;

  return <InlineBuilderItinerary {...props} />;
}

export default PageHeader;
